import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    limitExceeded: { color: theme.oysterTheme.shark, fontSize: '12px', fontStyle: 'italic' },
  }),
);

export default useStyles;
